var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { getManualAccountSelectionsPeformed, selectAccountByNumber } from './CustomerList';
var AccountInitializer = /** @class */ (function () {
    function AccountInitializer() {
        this.changingAccount = false;
        this.disableAutomaticRouting = false;
        this.accountSelectorLevels = [];
        this.firstRedirection = true;
        this.loadingWorkingLocation = false;
        this.forceAccountSelection = false;
        this.running = false;
        this.forceRender = function () { };
    }
    AccountInitializer.getAccountNumberFromURL = function () {
        var _a = __read(window.location.pathname.split('/'), 2), accountNumber = _a[1];
        // account number shuld be 7 digits
        if (/^\d{7}$/.test(accountNumber || '') === false)
            return '';
        return accountNumber;
    };
    AccountInitializer.prototype.hasMultupleAccounts = function () {
        var _a, _b;
        var grants = ((_b = (_a = this.centralContext) === null || _a === void 0 ? void 0 : _a.centralProfile) === null || _b === void 0 ? void 0 : _b.grants) || [];
        var counters = {
            ST: new Map(),
            BT: new Map(),
            HO: new Map(),
            PC: new Map(),
        };
        grants.forEach(function (g) {
            g.accounts.forEach(function (a) {
                var ct = a.customer_type.toLocaleUpperCase();
                counters[ct].set(a.customer_number, true);
            });
        });
        var pcCount = counters.PC.size;
        var hoCount = counters.HO.size + (pcCount > 0 ? 2 : 0);
        var btCount = counters.BT.size + (hoCount > 0 ? 2 : 0);
        var stCount = counters.ST.size + (btCount > 0 ? 2 : 0);
        if (this.accountSelectorLevels.includes('ST') && stCount > 1)
            return true;
        if (this.accountSelectorLevels.includes('BT') && btCount > 1)
            return true;
        if (this.accountSelectorLevels.includes('HO') && hoCount > 1)
            return true;
        if (this.accountSelectorLevels.includes('PC') && pcCount > 1)
            return true;
        return false;
    };
    AccountInitializer.prototype.needsToPickAChildLocation = function () {
        var _a, _b;
        var grants = ((_b = (_a = this.centralContext) === null || _a === void 0 ? void 0 : _a.centralProfile) === null || _b === void 0 ? void 0 : _b.grants) || [];
        var counters = {
            ST: new Map(),
            BT: new Map(),
            HO: new Map(),
            PC: new Map(),
        };
        grants.forEach(function (g) {
            g.accounts.forEach(function (a) {
                var ct = a.customer_type.toLocaleUpperCase();
                counters[ct].set(a.customer_number, true);
            });
        });
        var pcCount = counters.PC.size;
        var hoCount = counters.HO.size + (pcCount > 0 ? 2 : 0);
        var btCount = counters.BT.size + (hoCount > 0 ? 2 : 0);
        if (!this.accountSelectorLevels.includes('PC') && pcCount > 0)
            return true;
        if (!this.accountSelectorLevels.includes('HO') && hoCount > 0)
            return true;
        if (!this.accountSelectorLevels.includes('BT') && btCount > 0)
            return true;
        return false;
    };
    AccountInitializer.prototype.mustDisplayAccountSelector = function () {
        if (!this.centralContext)
            return false;
        if (getManualAccountSelectionsPeformed() > 0)
            return false;
        if (this.forceAccountSelection)
            return true;
        if (this.centralContext.hasFullAccountAccess('any') || this.hasMultupleAccounts()) {
            if (this.disableAutomaticRouting)
                return true;
            if (!AccountInitializer.getAccountNumberFromURL())
                return true;
            return false;
        }
        return false;
    };
    AccountInitializer.prototype.shouldDisplayUserAvatar = function () {
        if (this.mustDisplayAccountSelector() || this.changingAccount)
            return false;
        return true;
    };
    AccountInitializer.prototype.shouldDisplayAccountSelector = function () {
        if (this.loadingWorkingLocation)
            return false;
        if (this.changingAccount)
            return false;
        return this.mustDisplayAccountSelector();
    };
    AccountInitializer.prototype.setChangingAccount = function (changingAccount) {
        this.changingAccount = changingAccount;
        var forcedAccountSelection = this.mustDisplayAccountSelector();
        if (!this.centralContext)
            return;
        this.centralContext.setSelectingGrant(this.changingAccount || forcedAccountSelection);
    };
    AccountInitializer.prototype.initialize = function () {
        var _this = this;
        if (!this.history)
            return;
        if (!this.centralContext)
            return;
        var selectedGrant = this.centralContext.selectedGrant;
        var selectedGrantLocation = this.centralContext.selectedGrantLocation;
        if (!selectedGrantLocation && selectedGrant) {
            selectedGrantLocation = { customer_type: '' };
        }
        if (this.disableAutomaticRouting)
            return;
        if (!selectedGrantLocation)
            return;
        var accountNumber = AccountInitializer.getAccountNumberFromURL();
        var customerType = (selectedGrantLocation && selectedGrantLocation.customer_type.toLocaleUpperCase()) || '';
        if (!this.accountSelectorLevels.includes(customerType) && accountNumber === selectedGrantLocation.customer_number) {
            this.history.push('/');
            return;
        }
        if (this.firstRedirection) {
            this.firstRedirection = false;
            var loadWorkingLocationFromURL = function () { return __awaiter(_this, void 0, void 0, function () {
                var success;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.centralContext)
                                return [2 /*return*/];
                            if (!this.history)
                                return [2 /*return*/];
                            setTimeout(function () { return _this.setChangingAccount(true); }, 0);
                            return [4 /*yield*/, selectAccountByNumber(accountNumber, this.centralContext, this.accountSelectorLevels)];
                        case 1:
                            success = _a.sent();
                            setTimeout(function () {
                                _this.setChangingAccount(false);
                                _this.forceRender(1);
                            }, 100);
                            if (!success)
                                this.history.push('/');
                            return [2 /*return*/];
                    }
                });
            }); };
            if (accountNumber && accountNumber.length === 7) {
                this.loadingWorkingLocation = true;
                loadWorkingLocationFromURL().finally(function () { _this.loadingWorkingLocation = false; });
                return;
            }
        }
        if (this.loadingWorkingLocation || this.mustDisplayAccountSelector())
            return;
        if (this.accountSelectorLevels.includes(customerType) && accountNumber !== selectedGrantLocation.customer_number) {
            setTimeout(function () { var _a; return (_a = _this.history) === null || _a === void 0 ? void 0 : _a.push("/".concat(selectedGrantLocation === null || selectedGrantLocation === void 0 ? void 0 : selectedGrantLocation.customer_number)); }, 0);
        }
    };
    AccountInitializer.prototype.run = function (disableAutomaticRouting, accountSelectorLevels, forceAccountSelection, centralContext, history, forceRender) {
        this.disableAutomaticRouting = disableAutomaticRouting || false;
        this.accountSelectorLevels = accountSelectorLevels || ['PC', 'HO', 'BT', 'ST'];
        this.forceAccountSelection = forceAccountSelection || false;
        this.centralContext = centralContext;
        this.history = history;
        this.forceRender = forceRender;
        if (this.running)
            return;
        this.running = true;
        this.initialize();
        this.running = false;
    };
    return AccountInitializer;
}());
export var accountInitializer = new AccountInitializer();
//# sourceMappingURL=AccountInitializer.js.map